export const defaultAddressTypes = ["ADR_SOC"];
